var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46299 11.0137L11.2322 7.20597C11.3351 7.06466 11.3873 6.90093 11.3873 6.73678C11.3873 6.5997 11.3513 6.46263 11.2779 6.33739C11.1173 6.06239 10.8048 5.89062 10.4642 5.89062L4.92576 5.89062C4.58514 5.89062 4.27268 6.06239 4.11207 6.33739C4.03868 6.46262 4.00268 6.5997 4.00268 6.73678C4.00268 6.90093 4.05484 7.06466 4.15776 7.20639L6.92699 11.0141C7.09822 11.2493 7.38622 11.3906 7.69499 11.3906C8.00376 11.3906 8.29176 11.2493 8.46299 11.0137Z",
    fill: "#858A94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.7491bb150123e54b057939faab3c55d6.svg";
export { ForwardRef as ReactComponent };